module.exports = __webpack_public_path__ + "img/logocai@2x.b5df9010.png";